import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';

function SectionServiceChannels() {
  return (
    <Section minHeight="auto">
      <Block
        alignItems="center"
        textAlign="center"
        blockWidth="100%"
      >
        <Typography
          color="black"
          colorVariant="default"
          variant="title"
          gutterBottom={2}
          intlKey="SERVICE_CHANNELS.TITTLE"
          intlValues={{ br: <br /> }}
        />
        <Typography
          variant="paragraph2"
          color="black"
          colorVariant="default"
          gutterBottom={1}
          intlKey="SERVICE_CHANNELS.DESC"
        />
        <Typography
          intlKey="SERVICE_CHANNELS.LAST_UPDATE"
          variant="paragraph2"
        />
      </Block>
    </Section>
  );
}

export default React.memo(SectionServiceChannels);
